import { useEffect, useState } from "react";
import { Button, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link, NavLink, useLocation, useMatch } from "react-router-dom";
import PlanamotoMark from "./PlanamotoMark";
import { goToApp } from "../siteLinks";

// Marketing-site header. No auth state — Log in always shows and
// cross-origins into the app. Internal links (Explore, Guides) stay on
// the marketing origin via React Router NavLinks with active-state
// styling. Sticky so the nav is always reachable on long pages like the
// homepage.
export default function PublicHeader() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const location = useLocation();

    // useMatch handles nested matches — /explore/:slug keeps "Explore tours"
    // active, /guides/packing-europe keeps "Guides" active. NavLink's `end`
    // semantics aren't expressive enough on their own.
    const exploreActive = !!useMatch({ path: "/explore/*", end: false });
    const guidesActive = !!useMatch({ path: "/guides/*", end: false });

    // Close the mobile drawer whenever the route changes.
    useEffect(() => {
        setDrawerOpen(false);
    }, [location.pathname]);

    const navLinkClass = (active: boolean) =>
        active ? "gt-nav-link is-active" : "gt-nav-link";

    return (
        <header
            style={{
                position: "sticky",
                top: 0,
                zIndex: 10,
                background: "var(--gt-bg)",
                borderBottom: "1px solid var(--gt-border)",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: 64,
                    padding: "0 16px",
                    maxWidth: 1200,
                    width: "100%",
                    margin: "0 auto",
                    boxSizing: "border-box",
                }}
            >
                <Link
                    to="/"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        textDecoration: "none",
                    }}
                >
                    <PlanamotoMark
                        size={32}
                        title="Planamoto"
                        style={{ color: "var(--gt-primary)" }}
                    />
                    <span
                        className="gt-wordmark"
                        style={{ color: "var(--gt-text)" }}
                    >
                        Planamoto
                    </span>
                </Link>

                <nav className="gt-nav-desktop" aria-label="Primary">
                    <NavLink to="/explore" className={navLinkClass(exploreActive)}>
                        Explore tours
                    </NavLink>
                    <NavLink to="/guides" className={navLinkClass(guidesActive)}>
                        Guides
                    </NavLink>
                    <span style={{ width: 8 }} />
                    <Button type="primary" onClick={() => goToApp("/login")}>
                        Log in
                    </Button>
                </nav>

                <Button
                    className="gt-nav-mobile-toggle"
                    type="text"
                    icon={<MenuOutlined />}
                    aria-label="Open menu"
                    onClick={() => setDrawerOpen(true)}
                />
            </div>

            <Drawer
                placement="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                width={280}
                title="Menu"
            >
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <NavLink
                        to="/explore"
                        className={navLinkClass(exploreActive)}
                        style={{ padding: "12px 8px", fontSize: 16 }}
                    >
                        Explore tours
                    </NavLink>
                    <NavLink
                        to="/guides"
                        className={navLinkClass(guidesActive)}
                        style={{ padding: "12px 8px", fontSize: 16 }}
                    >
                        Guides
                    </NavLink>
                    <div style={{ height: 12 }} />
                    <Button block type="primary" onClick={() => goToApp("/login")}>
                        Log in
                    </Button>
                </div>
            </Drawer>
        </header>
    );
}
